import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-feature-box',
    templateUrl: './feature-box.component.html',
    styleUrls: ['./feature-box.component.scss']
})
export class FeatureBoxComponent {
    @Input() features = [];
    @Input() isFirst: boolean = false;
    @Input() isLast: boolean = false;
}